import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';

import Loader from '@/components/common/Loader/Loader';
import LoadingPage from '@/components/common/LoadingPage/LoadingPage';
import type { MealPlanQuizRecordModelType } from '@/models/api';
import { initializeStore } from '@/models/root-store';
import { getAllMealPlanQuizQuestions } from '@/utils/api-helpers';

const MealPlanFlow = dynamic(
  () => import('@/components/mealPlan/MealPlanFlow'),
  { ssr: false, loading: () => <LoadingPage /> },
);

type MealPlanType = {
  quizQuestions: MealPlanQuizRecordModelType[];
};

const MealPlan: NextPage<MealPlanType> = ({ quizQuestions }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      {isLoading && <Loader />}
      <MealPlanFlow quizQuestions={quizQuestions} setIsLoading={setIsLoading} />
    </>
  );
};

export async function getStaticProps() {
  const store = initializeStore({ ssr: true });
  const quizQuestions = await getAllMealPlanQuizQuestions(store);
  return {
    props: {
      quizQuestions,
    },
  };
}

export default MealPlan;
